import { dateTimeToString } from 'common/utils/date/Date.utils';
import React from 'react';
import PropTypes from 'prop-types';

function UserActivitiesTableRow({ item }) {
  const { dateTime, description, device } = item;

  return (
    <>
      <td>{dateTimeToString(dateTime)}</td>
      <td>{description}</td>
      <td>{device}</td>
    </>
  );
}

UserActivitiesTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default UserActivitiesTableRow;
